(function() {
    function updateTrustbadgeAlts() {
        // Main Trustbadge logo
        var badgeLogo = document.querySelector(
            'img[src*="trustedshops.com"][alt="Trusted Shops Gütesiegel"]'
        );
        if (badgeLogo) {
            badgeLogo.alt = "Mein eigener ALT Text hier"; // Replace with your alt
        }

        // Star images (yellow and gray)
        var stars = document.querySelectorAll(
            'img[src*="trustedshops.com"][src*="sprite"][data-testid^="rating-star"]'
        );
        for (var i = 0; i < stars.length; i++) {
            stars[i].alt = "Trustbadge Bewertung Stern " + (i + 1);
        }

        // Ellipsis icon (if used as <img>)
        var ellipsisImg = document.querySelector(
            'img[src*="sprite"][src*="ellipsis-light"]'
        );
        if (ellipsisImg) {
            ellipsisImg.alt = "Weitere Optionen";
        }

        // Ellipsis icon (if used as inline <svg><use>)
        var ellipsisSvg = document.querySelector(
            'svg use[href*="ellipsis-light"], svg use[xlink\\:href*="ellipsis-light"]'
        );
        if (ellipsisSvg && ellipsisSvg.ownerSVGElement) {
            var svg = ellipsisSvg.ownerSVGElement;
            if (!svg.querySelector("title")) {
                var title = document.createElementNS("http://www.w3.org/2000/svg", "title");
                title.textContent = "Weitere Optionen";
                svg.insertBefore(title, svg.firstChild);
            }
            svg.setAttribute("role", "img");
            svg.setAttribute("aria-label", "Weitere Optionen");
        }
    }

    // Run immediately
    updateTrustbadgeAlts();

    // Watch for dynamic inserts
    var observer = new MutationObserver(function() {
        updateTrustbadgeAlts();
    });
    observer.observe(document.body, { childList: true, subtree: true });
})();